import { ErrorStatusPage } from './ErrorStatusPage';

export function NotFoundPage() {
    return (
        <ErrorStatusPage
            code={404}
            title="الصفحة غير موجودة"
            description="عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها أو حذفها. تأكد من الرابط أو ارجع للصفحة الرئيسية."
        />
    );
}

export default NotFoundPage;
